import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export default function Loading() {
  return (
    <Card className="w-full max-w-md m-auto">
      <CardHeader>
        <CardTitle>Lade Daten</CardTitle>
        <CardDescription>
          Bitte warten Sie, während wir die neuesten Daten abrufen.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col items-center justify-center gap-4 py-8">
        <Skeleton className="h-12 w-12 rounded-full" />
        <div className="space-y-2 text-center">
          <Skeleton className="h-4 w-[200px]" />
          <Skeleton className="h-4 w-[180px]" />
        </div>
        <div className="space-y-2 text-center">
          <p className="text-sm text-muted-foreground">
            Connecting people is the foundation of progress.
          </p>
        </div>
      </CardContent>
    </Card>
  );
}
